import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { stringify } from 'querystring';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, DateTime, Autocomplete } from '~/components/Form';
import { t } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import { validation, validationErrors } from '~/helpers/yupValidations';
import api from '~/services/api';
import { updateData } from '~/store/modules/EdicaoOperacao/TrocaTanque/actions';

export default function FormUpdate({ reference, data, create }) {
  const [reservoir, setReservoir] = useState({});
  const [load, setLoad] = useState(false);

  const { loading, find, params } = useSelector(
    (state) => state.edicaoTrocaTanque
  );

  const dispatch = useDispatch();
  const initials = create ? data : { ...find, ...data };

  const handleSubmit = useCallback(
    async (formData) => {
      try {
        const schema = Yup.object().shape({
          idtanquevirtualalinhadotrocatanque: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
        });

        await validation(schema, formData);

        dispatch(updateData({ ...initials, ...formData }, params));
      } catch (err) {
        validationErrors(err, reference);
      }
    },
    [initials]
  );

  const handleGetParamsReservoir = useCallback(async ({ id, post }) => {
    try {
      setLoad(true);

      await api
        .get('tanquesvirtuais', {
          params: {
            wherefield: ['idtanquevirtual', 'idposto'],
            valuewherefield: [id, post],
            typewherefield: ['EQUALS', 'EQUALS'],
          },
          paramsSerializer: (param) => stringify(param),
        })
        .then((response) => setReservoir(response.data.items.shift()));
    } catch (err) {
      getToastErrors(err);
    } finally {
      setLoad(false);
    }
  }, []);

  useEffect(() => {
    const { idtanquevirtualanteriortrocatanque, idposto } = initials;

    if (idtanquevirtualanteriortrocatanque && idposto) {
      handleGetParamsReservoir({
        id: idtanquevirtualanteriortrocatanque,
        post: idposto,
      });
    }
  }, [initials.idtanquevirtualanteriortrocatanque]);

  if (loading || load || isEmpty(reservoir))
    return (
      <div style={{ height: '14rem', width: '50rem' }}>
        <Spinner loading />
      </div>
    );

  return (
    <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
      <Input disabled name="idposto" label={t('s.relatorio.geral.unidade')} />

      <Input disabled name="idbico" label={t('s.menu.configuracao.bico')} />

      <DateTime
        time
        disabled
        name="datahorainiciotrocatanque"
        label={t('s.geral.opcoes.datahorainicial')}
      />

      <DateTime
        time
        disabled
        name="datahorafimtrocatanque"
        label={t('s.geral.opcoes.datahorafinal')}
      />

      <Autocomplete
        disabled
        name="idtanquevirtualanteriortrocatanque"
        label="idtanquevirtual"
        url="tanquesvirtuais"
        unique="idtanquevirtual"
        title={t('s.operacao.edicaotrocatanque.tanqueanterior')}
      />

      <Autocomplete
        name="idtanquevirtualalinhadotrocatanque"
        label="idtanquevirtual"
        url="tanquesvirtuais"
        unique="idtanquevirtual"
        title={t('s.operacao.edicaotrocatanque.tanquealinhado')}
        params={{
          wherefield: ['idposto', 'idproduto'],
          valuewherefield: [reservoir.idposto, reservoir.idproduto],
          typewherefield: ['EQUALS', 'EQUALS'],
        }}
      />
    </Form>
  );
}

FormUpdate.propTypes = {
  reference: PropTypes.any.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
};
